export default __webpack_public_path__ + "static-json/ne_110m_lakes-8a35b48a9c2105c4c595c4e5db38df5b.json";